import * as ACTION_TYPES from './Types';

const initialState = {
  commission:{},
  customercmn:{},
  dealercmn:{},
  mfrcmn:{},
  dealerEarning:{},
  mfrEarning:{},
  message: '',
  error: null,
}

export const commissionReducer = (state = initialState, action) => {
  switch (action.type) {


    case ACTION_TYPES.GET_COMMISSION_SUCCESS:  
      return {
          ...state,
          commission:action.payload.data,
          message: action.payload.message,
      }
      case ACTION_TYPES.CUSTOMER_COMMISSION_SUCCESS:  
      return {
          ...state,
          customercmn:action.payload.data,
          message: action.payload.message,
      }
      case ACTION_TYPES.DEALER_COMMISSION_SUCCESS:  
      return {
          ...state,
          dealercmn:action.payload.data,
          message: action.payload.message,
      }
      case ACTION_TYPES.MFR_COMMISSION_SUCCESS:  
      return {
          ...state,
          mfrcmn:action.payload.data,
          message: action.payload.message,
      }
      case ACTION_TYPES.DEALER_EARNING_SUCCESS:  
      return {
          ...state,
          dealerEarning:action.payload.data,
          message: action.payload.message,
      }
      case ACTION_TYPES.MFR_EARNING_SUCCESS:  
      return {
          ...state,
          mfrEarning:action.payload.data,
          message: action.payload.message,
      }
    case ACTION_TYPES.UPDATE_COMMISSION_SUCCESS:
    case ACTION_TYPES.UPDATE_COMMISSION_ERROR: 
    case ACTION_TYPES.GET_COMMISSION_ERROR:
    case ACTION_TYPES.CUSTOMER_COMMISSION_ERROR:
      case ACTION_TYPES.DEALER_COMMISSION_ERROR: 
      case ACTION_TYPES.MFR_COMMISSION_ERROR:  
      case ACTION_TYPES.DEALER_EARNING_ERROR:  
      case ACTION_TYPES.MFR_EARNING_ERROR:  


      return {
        ...state,
        message: action.payload.message,
      } 
      
    default:
      return state;
  }
}
